// extracted by mini-css-extract-plugin
export default {"Empty":"EmptyState_Empty__sbwb4","action":"EmptyState_action__mHz2p"};